module.exports = __webpack_public_path__ + "img/-s-Group-21@2x.b258415c.png";